import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';

export const useConversationHistoryStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      gap: '18px',
    },
    scrollableContent: {
      flex: 1,
      overflowY: 'auto',
      padding: theme.spacing(0, 1, 1),
      '&::-webkit-scrollbar': {
        backgroundColor: theme.palette.background.default,
        scrollbarWidth: 'thin',
        width: '6px',
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: theme.palette.background.paper,
        // outline: `1px solid ${theme.palette.divider}`,
      },
      '&::-webkit-scrollbar-thumb': {
        maxWidth: '2px',
        backgroundColor: theme.palette.grey[500],
        borderRadius: '10px',
        border: `2px solid ${theme.palette.background.paper}`,
      },
    },
    loadingContainer: {
      display: 'flex',
      justifyContent: 'center',
      padding: theme.spacing(4),
    },
    errorText: {
      padding: theme.spacing(2),
      textAlign: 'center',
    },
    noSearchResults: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: theme.spacing(4),
      color: theme.palette.text.secondary,
    },
    noSearchIcon: {
      fontSize: 48,
      marginBottom: theme.spacing(2),
      opacity: 0.5,
    },
    emptyState: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: theme.spacing(2),
      color:
        theme.palette.mode === 'dark'
          ? 'var(--xlrt-color-ui-gray60)'
          : 'var(--xlrt-color-ui-gray45)',
      gap: '8px',
      '& .emptyStateHint': {
        color:
          theme.palette.mode === 'dark'
            ? 'var(--xlrt-color-ui-gray45)'
            : 'var(--xlrt-color-ui-gray60)',
      },
    },
    sectionHeader: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(0.5),
      padding: theme.spacing(1, 0.5),
      color: 'var(--xlrt-color-ui-gray60)',
    },
    sectionIcon: {
      fontSize: 14,
    },
    sectionTitle: {
      fontWeight: 600,
      textTransform: 'uppercase',
    },
    list: {
      padding: 0,
    },
    divider: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  }),
  { name: 'ConversationHistory' },
);
